import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import _ from 'lodash'
import ReactTimeout from 'react-timeout'
import { useDispatch, useSelector } from 'react-redux'
import { addTimeslotsOccupied } from 'services/redux/data/actions'
import { cartConstants } from 'services/redux/cart/constants'
import HelperTimeslot from 'utils/helper-timeslot'
import { useEffect, useRef } from 'react'
import { useIsFocused } from '@react-navigation/native'
import store from 'services/redux/store'
import HelperDate, { dateFormat } from 'utils/helper-date'

const CapacityFetcher = ({ building, floor, room, timeslots, setTimeout, clearTimeout, timeslotKinds, timeslotSubKinds, callback }) => {
	
	const isFocused = useIsFocused();
	const timeout = useRef();
	const dispatch = useDispatch()
	
	const graphqlBuilderRef = useRef( null )
	const isFetching = useRef( false )
	
	const _bookDate = useSelector( state => {
		return state.cart[cartConstants.BOOK_DATE];
	} );
	const _cartBookings = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	
	const fetchCapacity = () => {
		// Check if timeslot exists for this day
		const now = HelperDate.date();
		
		// Get latest book date
		const timeslotDate = store.getState().cart[ cartConstants.BOOK_DATE ] ?? HelperDate.date()
		
		const timeslotDateFormatted = timeslotDate.format( dateFormat.DATE );
		const timeslotDateFormattedPretty = timeslotDate.format( dateFormat.DATE_PRETTY );
		
		// Create the slots
		const slots = [];
		
		_.forEach( timeslots, timeslotsKind => {
			_.forEach( _.filter( timeslotsKind, { timeslot_day: timeslotDate.isoWeekday() } ), slot => {
				// Create the moment object for the timeslot datetime
				const slotEnd = HelperDate.date( timeslotDateFormatted +" "+ slot.timeslot_end );
				
				// Only add the slot when it is after NOW
				if( slotEnd.isAfter( now ) && _.includes( timeslotKinds, slot?.kind ) && timeslotSubKinds.includes( slot?.sub_kind ) ) {
					slots.push( slot );
				}
			});
		});
		
		// Create object
		const day = {
			dayjs: timeslotDate,
			date: timeslotDateFormattedPretty,
			bookingDate: timeslotDateFormatted,
			slots: slots
		};

		if( _.size( slots ) === 0 ) {
			// Still do the callback
			if( _.isFunction( callback ) ) {
				callback( day, HelperTimeslot.createFlat({ building, floor, room, day } ) );
			}
			return;
		}
		
		// Do not fetch again when same date
		if( isFetching.current === day.bookingDate ) {
			return;
		}
		
		// Cancel the current old request
		graphqlBuilderRef.current?.cancelTokenSource?.cancel('Cancel old date')
		
		// Set the date
		isFetching.current = day.bookingDate;

		clearTimeout( timeout.current )
		graphqlBuilderRef.current = FetchTimeslotCapacity.fetch({
			building: building,
			floor: floor,
			room: room,
			timeslots: day.slots,
			dates: [
				day.bookingDate
			],
			// Add bookings
			bookings: [
				...Object.values( _cartBookings ),
			],
			callbackSuccess: result => {
				if( _.size( result ) > 0 ) {
					dispatch( addTimeslotsOccupied( result ) )
				}
				
				fetchCapacityTimeout();
				
				if( _.isFunction( callback ) ) {
					callback( day, HelperTimeslot.createFlat({ building, floor, room, day } ) );
				}
			},
			callbackError: fetchCapacityTimeout
		});
	}
	
	const fetchCapacityTimeout = ( e ) => {
		console.log('testy5', 'error', e );

		isFetching.current = false;
		timeout.current = setTimeout( fetchCapacity, 10000 );
	}
	
	useEffect( () => {
		if( !isFocused ) {
			clearTimeout( timeout.current )
		} else {
			fetchCapacity();
		}
	}, [ isFocused, _bookDate, timeslots ] )
	
	return null;
}

export default ReactTimeout( CapacityFetcher )
